import React from 'react';
interface AdminBrandProps {
  compact?: boolean;
}
const LOGO_COLOR = 'https://cdn.magicpatterns.com/uploads/fdWnQMUp9fhE8KAVDmQakg/AZ_Logo_final_Colores.png';
export function AdminBrand({
  compact = false
}: AdminBrandProps) {
  return <div className="flex min-w-0 items-center gap-3" data-id="element-64">
      <img src={LOGO_COLOR} alt="Estrategias Digitales A-Z" className={compact ? 'h-9 w-auto' : 'h-11 w-auto'} data-id="element-65" />
      <span className="h-8 w-px bg-white/15" aria-hidden="true" data-id="element-66" />
      <div className="min-w-0" data-id="element-67">
        <p className="font-orbitron text-sm font-bold tracking-[0.18em] text-white" data-id="element-68">
          TITÁN OS
        </p>
        {!compact && <p className="mt-0.5 text-xs text-slate-400" data-id="element-69">Acceso administrativo</p>}
      </div>
    </div>;
}